import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import {
  Analytics,
  AnalyticsCallOptions,
  initializeAnalytics,
  logEvent,
  setUserProperties,
} from 'firebase/analytics';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FirebaseAnalyticsService {
  private analytics?: Analytics;
  private initialized = false;

  public init(): void {
    if (!environment.analytics) {
      console.warn('[Analytics] Skipped initialization (disabled by env)');
      return;
    }
    if (this.initialized) {
      console.warn('[Analytics] Already initialized');
      return;
    }
    const app = initializeApp(environment.firebaseConfig);
    this.analytics = initializeAnalytics(app, {
      config: {
        send_page_view: false,
      },
    });
    setUserProperties(this.analytics, { application: 'kq' });
    this.initialized = true;
  }

  public logEvent(
    eventName: string,
    eventParams?: Record<string, unknown>,
    options?: AnalyticsCallOptions,
  ): void {
    if (!this.analytics) {
      if (environment.analytics) {
        console.warn(
          "Analytics service is not initialized. Would've sent event:",
          eventName,
          eventParams,
          options,
        );
      }
      return;
    }

    logEvent(this.analytics!, eventName, eventParams, options);
  }
}
